<template>
  <el-row :gutter="20" class="main_block">
    <div class="mianContent">
      <div class="tagView">
        <div class="title_aside"></div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="searchBar">
        <el-date-picker
            v-model="value1"
            type="datetimerange"
            align="right"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :default-time="['12:00:00', '08:00:00']"
        >
        </el-date-picker>
        <el-button type="primary" @click="searchData" style="margin-left: 15px">查询</el-button>
        <el-button type="warning" @click="reset">重置</el-button>
      </div>
      <div class="tableBox">
        <ExTable
            :table-list="tableData"
            :header="header"
            height="300"
            :isIndex="true"
            :total="total"
            :activeIndex='searchParam.page'
            :pageSizeNum='pageSizeNum'
            @clickPage="clickPage"
            @clickSize="clickSize"
        />
      </div>
    </div>
  </el-row>
</template>

<script>
import ExTable from "@com/ExTable";
import {signUser} from "@http/user_center/agreeMent";
import {formatDate,filterParams} from "@/utils/filter";
export default {
  name: "agreeMent",
  data() {
    return {
      value1: [],
      tabheight: "100%",
      header: [
        {prop: "filename", label: "协议名称"},
        {prop: "applicant", label: "用户"},
        {
          prop: "updatedAt",
          label: "时间",
          formatter: (row) => {
            return formatDate(row.updatedAt);
          },
        },
        {
          label: "操作",
          render: (h, data) => {
            return (
                <div>
                  <el-tooltip
                      class="item"
                      effect="dark"
                      content="查看"
                      placement="top"
                  >
                    <el-button
                        icon="el-icon-view"
                        onClick={() => {
                          console.log(
                              "http://evidence-public.tsa.cn/pdf/web/viewer.html#" +
                              data.row.pdfUrl
                          );
                          data.row.pdfUrl
                              ? window.open(
                              "http://evidence-public.tsa.cn/pdf/web/viewer.html#" +
                              data.row.pdfUrl
                              )
                              : "";
                        }}
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                      class="item"
                      effect="dark"
                      content="下载"
                      placement="top"
                  >
                    <el-button
                        icon="el-icon-download"
                        onClick={() => {
                          data.row.pdfUrl ? window.open(data.row.pdfUrl) : "";
                        }}
                    ></el-button>
                  </el-tooltip>
                </div>
            );
          },
        },
      ],
      searchParam: {
        page: 1,
        size: 10,
        startCreatedAt:'',
        endCreatedAt:'',
      },
      pageSizeNum:10,
      tableData: [],
      total:10,
    };
  },
  components: {
    ExTable,
  },
  created() {
    this.searchData();
  },
  methods: {
    async getTableData(searchParam) {
      try {
        const {data, total} = await signUser(searchParam);
        this.tableData = data
        this.total = total
      } catch (error) {
        this.tableData = []
      }
    },
    searchData() {
      this.searchParam.page = 1
      if (this.value1 !== [] && this.value1 !== null) {
        this.searchParam.startCreatedAt=this.value1[0];
        this.searchParam.endCreatedAt=this.value1[1];
      }
      this.getTableData(filterParams(this.searchParam));
    },
    clickPage(page) {
      this.searchParam.page = page;
      this.getTableData(filterParams(this.searchParam));
    },
    clickSize(size) {
      this.pageSizeNum = size
      this.searchParam.page = 1;
      this.searchParam.size = size;
      this.getTableData(filterParams(this.searchParam));
    },
    reset(){
        this.value1=[]
        this.searchParam.page = 1
        this.searchParam.startCreatedAt = ''
        this.searchParam.endCreatedAt = ''
        this.getTableData(filterParams(this.searchParam))
    }
  },
};
</script>

<style scoped>
</style>
